/**
 * Per-tool status logic for the reasoning timeline (no JSX — see toolStatus.tsx
 * for the matching RunningIndicator component).
 *
 * A tool result may carry a `status` of 'running' | 'done' | 'error'. Older
 * (historical) results have no status at all — those are treated as completed so
 * they still render a green check rather than a stuck spinner.
 */

interface ToolStatusShape {
  status?: 'running' | 'done' | 'error';
  result?: unknown;
  error?: string;
}

/**
 * A tool is "in flight" only when it is explicitly running AND has not yet
 * produced a result or error. Missing status (legacy data) is never running.
 */
export function isToolRunning(tool: ToolStatusShape): boolean {
  if (tool.status !== 'running') {
    return false;
  }
  const hasResult = tool.result !== null && tool.result !== undefined;
  const hasError = !!tool.error;
  return !hasResult && !hasError;
}
